import axios from "axios";
export const API_URL = "/api/v1";
export const GET_COLLCET_ZONE_LIST = API_URL+"/search/get_collect_zone_list/";
export const DELETE_COLLECT_ZONE_URL = API_URL+"/search/";
export const SAVE_COLLECT_ZONE_LIST = API_URL+"/search/save_collect_zone/";
export const GET_CAR_LIST = API_URL+"/search/get_car_list/";
export const GET_DRIVER_LIST = API_URL+"/search/get_driver_list/";
export const GET_BOARD_LIST = API_URL+"/search/get_board_list/";
export const GET_BOARD_DETAIL = API_URL+"/search/get_board_detail/";
export const SAVE_BOARD_DATA = API_URL+"/search/save_board_data/";
export const UPDATE_BOARD_DATA = API_URL+"/search/update_board_data/";
export const DELETE_BOARD_DATA = API_URL+"/search/delete_board_data/";


export function getCollectZoneList(params) {
  return axios.get(GET_COLLCET_ZONE_LIST);
}

export function deleteCollectZone(id) {
  return axios.delete(DELETE_COLLECT_ZONE_URL + id + "/");
}

export function saveCollectZone(params) {
  return axios.post(SAVE_COLLECT_ZONE_LIST, params);
}

export function getCarList() {
  return axios.get(GET_CAR_LIST);
}

export function getDriverList() {
  return axios.get(GET_DRIVER_LIST);
}

export function getBoardList(params) {
  return axios.get(GET_BOARD_LIST + '?page=' + params.page + '&username=' + params.username + '&subject=' + params.subject + '&content=' + params.content + '&type=' + params.type);
}

export function getBoardDetail(params) {
  return axios.get(GET_BOARD_DETAIL + '?id=' + params.id);
}

export function saveBoardData(fd) {
  return axios.post(SAVE_BOARD_DATA, fd, {headers: {'Content-Type': 'multipart/form-data'}});
}

export function deleteBoardData(params) {
  return axios.post(DELETE_BOARD_DATA, params);
}

export function updateBoardData(fd) {
  return axios.post(UPDATE_BOARD_DATA, fd, {headers: {'Content-Type': 'multipart/form-data'}});
}
